// extracted by mini-css-extract-plugin
export default {"wrapper":"private-page-layout_wrapper__tkRuX"};